// 수행평가
import Resource from '../Resource'
export default class PerformSelfTestAnswer extends Resource {
  static ENDPOINT = '/api/test/performself/answer'

  constructor (args) {
    super()
    this.extend(args)
  }

  static create (training, student, teacher, test) {
    const answer = {
      training,
      student,
      code: test.code,
      seq: 1,
      teacher,
      units: test.units.map(u => ({ answer: '' }))
    }
    for (let i = 0; i < answer.units.length; i++) {
      answer.units[i].answer = Array(test.units[i].content.length)
    }
    return new PerformSelfTestAnswer(answer)
  }
}
